import {USER_ROLES} from "@/constants";

export default class ProjectFoundationPolicy
{
    /**
     * Determine whether the user can view any models.
     *
     * @param  {object}  user
     * @return mixed
     */
    viewAny(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can view the model.
     *
     * @param  {object}  user
     * @param  {object}  projectfoundation
     * @return {mixed}
     */
    view(user, projectfoundation)
    {
        //
    }

    /**
     * Determine whether the user can create models.
     *
     * @param  {object}  user
     * @return {mixed}
     */
    create(user)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can update the model.
     *
     * @param  {object}  user
     * @param  {object}  projectfoundation
     * @return {mixed}
     */
    update(user, projectfoundation)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can restore the model.
     *
     * @param  {object}  user
     * @param  {object}  projectfoundation
     * @return {mixed}
     */
    restore(user, projectfoundation)
    {
        //
    }

    /**
     * Determine whether the user can delete the model.
     *
     * @param  {object}  user
     * @param  {object}  projectfoundation
     * @return {mixed}
     */
    delete(user, projectfoundation)
    {
        return [USER_ROLES.ADMIN, USER_ROLES.USER, USER_ROLES.CONSTRUCTION_MANAGER].includes(user.role);
    }

    /**
     * Determine whether the user can permanently delete the model.
     *
     * @param  {object}  user
     * @param  {object}  projectfoundation
     * @return {mixed}
     */
    forceDelete(user, projectfoundation)
    {
        //
    }
}
